import useMinWidth from './useMinWidth'

export function useIsMinWidthMd() {
  return useMinWidth('md')
}
